// extracted by mini-css-extract-plugin
export default {"container":"FreeProxy_container__prgoX","label":"FreeProxy_label__DZRvi"};